app.controller('userDefinedMainController', function($scope, appActivity, $stateParams, $document) 
{
  //Display Hot Alerts Class
  $scope.displayAlertClass = function(status)
  {
    var js_variable_mapping = $scope.js_variable_mapping;
    var hot_alert_map = typeof js_variable_mapping.hot_alert_map != 'undefined'?js_variable_mapping.hot_alert_map:[];
    var hot_alert_map_flipped = array_flip(hot_alert_map);
    
    //check if the value is defined in the alert map array
    var status_class = status in hot_alert_map_flipped?hot_alert_map_flipped[status]:'';
		return status_class;
	}
  
});
